import { Card, CardHeader, Typography, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { resetForm, setDialog } from "../../../../app/slices/patientSlice";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import PatientForm from "../../form";

const PatientHeader = () => {
  const _Patient = useSelector((state) => state.patient.patient);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            المراجعين
          </Typography>
        }
        avatar={<AiOutlineUsergroupAdd size={20} />}
        action={
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => {
              dispatch(setDialog());
              dispatch(resetForm());
            }}
          >
            إضافة مراجع جديد
          </Button>
        }
      />
      {_Patient.dialog ? <PatientForm /> : null}
    </Card>
  );
};

export default PatientHeader;
